module.exports = __webpack_public_path__ + "img/book.ced64b6a.svg";